module.exports = __webpack_public_path__ + "img/2.7c12d0c4.jpg";